import {guyouRaw} from "../guyou";
import quincuncial from "./index";

export default function() {
  return quincuncial(guyouRaw)
      .scale(111.48);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/d3-geo-projection/src/quincuncial/peirce.js
// module id = hYTW
// module chunks = 0